import type { HTMLAttributes, JSX } from "preact";
import { classNames } from "@gss/common/classNames";

interface Props extends HTMLAttributes<HTMLDivElement> {
    className?: string;
}

export function Card({ className, children, ...rest }: Props): JSX.Element {
    return (
        <div {...rest} className={classNames("card", className)}>
            {children}
        </div>
    );
}

export function CardHeader({
    className,
    onClick,
    children,
    ...rest
}: Props): JSX.Element {
    return (
        <div
            {...rest}
            className={classNames(
                "card-header",
                onClick != null && "clickable",
                className,
            )}
            onClick={onClick}
        >
            {children}
        </div>
    );
}

export function CardBody({ className, children, ...rest }: Props): JSX.Element {
    return (
        <div {...rest} className={classNames("card-body", className)}>
            {children}
        </div>
    );
}

export function CardFooter({
    className,
    children,
    ...rest
}: Props): JSX.Element {
    return (
        <div {...rest} className={classNames("card-footer", className)}>
            {children}
        </div>
    );
}
